import React from "react";
import ToolTipPopup from './toolTipPopup';
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "../../analytics/adobe/index";
import { addBankDataLayer } from "../../analytics/adobe/dataLayerValues";
import { PROFANITY_NICKNAME_CHECK } from "../../constants";

export class AddBankAccount extends React.Component {
  state = {
    invalidRoutingMessage: '',
    dupalicateNicknameMessage: '',
    dupalicateAccountMessage: '',
    profabityNicknameCheckMessage: '',
    routingNumber: '',
    accountNumber: '',
    confirmAccountNumber: '',
    nickname: '',
    externalAccountType: 'CHECKING',
    amount: '10000',
    currency: 'USD',
    inActive: "buttons-toggle-cust-unactive",
    valid: {
      rn: {
        isValid: false,
        icon: {
          classes: "hidden"
        },
        req: {
          classes: "hidden"
        },
        msg: ["This is a required field.", "The number of characters displayed cannot be less than 9", "The number of characters enetered cannot be less than 9"],
        index: 0
      },
      an: {
        isValid: false,
        icon: {
          classes: "hidden"
        },
        req: {
          classes: "hidden"
        },
        msg: ["This is a required field.", "The number of characters displayed cannot be less than 4"],
        index: 0
      },
      can: {
        isValid: false,
        icon: {
          classes: "hidden"
        },
        req: {
          classes: "hidden"
        },
        msg: ["This is a required field.", "The number of characters displayed cannot be less than 4", "Your confirm account number must match your current account number"],
        index: 0
      },
      nn: {
        isValid: false,
        req: {
          classes: "hidden"
        },
        msg: ["This is a required field."],
        index: 0
      }
    },
    switchButtonPrimarySecondary: false,
    showImg: false,
    showImgAcc: false,
    showNotValidError: false,
    showGlobalErr: false,
    showExternalAccountValidationGlobalMsg: false,
    externalParam: { accountType: null, retryFlag: false, coorelationId: null },
    commonErrors: "Please correct the errors on the field marked in red",
    popupWindow: false
  };

  componentDidMount(){
    const { pageName, siteSection }=addBankDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), false);
  }

  componentWillMount() {
    this.props.switchTabs({
      callBackFun: this.globalTabSwitch
    });
    let externalParam = { ...this.state.externalParam };
    externalParam.accountType=this.props.accountType;
    this.setState({ externalParam: externalParam });
  }
  globalTabSwitch=()=>{
    this.props.switchTabs(null);
    this.props.switchTab();
  }
  addBankAccount =() => {
    this.setState({ showExternalAccountValidationGlobalMsg: false, invalidRoutingMessage: '', dupalicateNicknameMessage: '', dupalicateAccountMessage: '' });
    let errorShow = this.isProfabityNickname(this.state.nickname);
    if(errorShow){
      this.setState({ profabityNicknameCheckMessage: 'Sorry, We have detected profanity in your nickname. Please modify your nickname and try again.' });
    }else{
      this.setState({ profabityNicknameCheckMessage: '' });
      let account = {
        routingNumber: this.state.routingNumber,
        accountNumber: this.state.accountNumber,
        confirmAccountNumber: this.state.confirmAccountNumber,
        nickname: this.state.nickname,
        externalAccountType: this.state.externalAccountType,
        amount: '10000',
        currency: 'USD',
        accountType: this.props.accountType,
        newAccount: true,
        accountAddedInSession: true
      };

      let isValid = (this.state.valid.rn.isValid && this.state.valid.an.isValid && this.state.valid.can.isValid
        && this.state.valid.nn.isValid);
      if (isValid) {
        this.props.addExternalBankAccount(account, this.state.externalParam, this.callbackFunction);
      }
    }
  }
  callbackFunction =(data)=>{
    if(data.statusCode === 200){
      this.setState({ showExternalAccountValidationGlobalMsg: false });
      this.globalTabSwitch();
      this.setState({ invalidRoutingMessage: '' });
    }
    if(data.statusCode === 400){
      this.setState({ invalidRoutingMessage: data.message, dupalicateNicknameMessage: '', dupalicateAccountMessage: '' });
      this.setState({ showExternalAccountValidationGlobalMsg: true });
    }
    if(data.statusCode === 401){
      if(data.applicationStatus==='nickname'){
        this.setState({ dupalicateNicknameMessage: data.message, invalidRoutingMessage: '', dupalicateAccountMessage: '' });
      } else if(data.applicationStatus==='accountnumber'){
        this.setState({ dupalicateAccountMessage: data.message, invalidRoutingMessage: '', dupalicateNicknameMessage: '' });
      }
      this.setState({ showExternalAccountValidationGlobalMsg: true });
    }
  }
  isAllConditionsValid = (valid) => {
    return ((valid.rn.isValid || (valid.rn.icon.classes !== "hidden" && valid.rn.req.classes !== "show"))
      && (valid.an.isValid || (valid.an.icon.classes !== "hidden" && valid.an.req.classes !== "show"))
      && (valid.can.isValid || (valid.can.icon.classes !== "hidden" && valid.can.req.classes !== "show"))
      && valid.nn.isValid);
  }
  onChange = (name, val) => {
    let obj = { ...this.state };
    obj[name] = val;
    this.setState({ ...obj });
  }
  doValidation =(obj)=>{
    let update={ ...this.state };
    let valid={ ...update.valid };
    let val = obj.val;
    valid[obj.field].isValid=false;
    if(obj.type === "icon"){
      if(val.length>=obj.size){
        if(obj.field === "can"){
          if(val === obj.compareWith){
            valid[obj.field][obj.type]={ classes: "" };
          }else{
            valid[obj.field][obj.type]={ classes: "hidden" };
          }
        } else if(obj.field === "rn" && this.onChangeNumberValidation(val)){
          this.setState({ routingNumber: "" });
        } else if(obj.field === "rn"){
          valid[obj.field][obj.type]={ classes: "" };
        } else if(obj.field === "an" && this.onChangeNumberValidation(val)){
          this.setState({ accountNumber: "" });
        } else{
          valid[obj.field][obj.type]={ classes: "" };
        }
      }else{
        valid[obj.field][obj.type]={ classes: "hidden" };
      }
      valid[obj.field].req={ classes: "hidden" };
      this.setState({ showGlobalErr: false });
    }else if(obj.type === "req"){
      if(val.length === 0){
        valid[obj.field].index=0;
        valid[obj.field][obj.type]={ classes: "" };
        if(obj.field === "nn"){
          valid[obj.field].index=0;
          valid[obj.field][obj.type]={ classes: "show" };
          this.setState({ showGlobalErr: true });
        }
      }else if(obj.field === "rn" && this.onChangeNumberValidation(val)){
        this.setState({ routingNumber: "" });
      }else if(obj.field === "an" && this.onChangeNumberValidation(val)){
        this.setState({ accountNumber: "" });
      }else if(obj.field === "nn" && this.onChangeNickNameValidation(val)){
        this.setState({ nickname: "" });
      }else if(obj.field === "rn" && val.length < 9){
        valid[obj.field].index=2;
        valid[obj.field][obj.type]={ classes: "show" };
        this.setState({ showGlobalErr: true });
      }else if(val.length < obj.size){
        valid[obj.field].index=1;
        valid[obj.field][obj.type]={ classes: "show" };
        this.setState({ showGlobalErr: true });
      }else if(obj.field === "can" && val !== obj.compareWith){
        valid[obj.field].index=2;
        valid[obj.field][obj.type]={ classes: "show" };
        this.setState({ showGlobalErr: true });
      }else{
        valid[obj.field][obj.type]={ classes: "hidden" };
        valid[obj.field].isValid=true;
        this.setState({ showGlobalErr: false });
      }
    }
    this.setState({ valid: { ...valid } });
    this.setState({
      invalidRoutingMessage: '',
      dupalicateNicknameMessage: '',
      dupalicateAccountMessage: '',
      profabityNicknameCheckMessage: ''
    });

  }
  togglePrimarySecondaryBtn = (type) => {
    this.setState({
      switchButtonPrimarySecondary: !this.state.switchButtonPrimarySecondary,
      externalAccountType: type
    });
  }
  showImgAccOnClick = () => {
    this.setState({ showImgAcc: !this.state.showImgAcc });
  }

  showImgOnClick = () => {
    this.setState({ showImg: !this.state.showImg });
  }
  validateAccountNumber = () => {
    if(this.state.accountNumber !== this.state.confirmAccountNumber) {
      this.setState({ showNotValidError: !this.state.showNotValidError });
    }
  }
  onPaste =()=>{
    this.setState({ confirmAccountNumber: "" });
  }

  togglePopupWindow =()=>{
    this.setState({ popupWindow: !this.state.popupWindow });
  };
  confirmAccountNumberValidation =()=>{
    this.setState({ showExternalAccountValidationGlobalMsg: false });
    this.doValidation({ type: "icon", field: "can", val: this.state.confirmAccountNumber, size: 4, compareWith: this.state.accountNumber });
    this.doValidation({ type: "req", field: "can", val: this.state.confirmAccountNumber, size: 4, compareWith: this.state.accountNumber });
  };

  isProfabityNickname =(val)=>(PROFANITY_NICKNAME_CHECK.indexOf(val) !== -1);
  nickNameValidation =(event)=>{
    if (!/^(?=[^\,]*(?:\,)?[^'&#()/,\.-]*$)[A-Za-z0-9'&#()/,\.-]*$/.test(this.state.nickname.substr(0, event.target.selectionStart) + event.key + this.state.nickname.substr(event.target.selectionStart)) ){ event.preventDefault(); }
  }
  onChangeNickNameValidation =(val)=>{
    return !/^(?=[^\,]*(?:\,)?[^'&#()/,\.-]*$)[A-Za-z0-9'&#()/,\.-]*$/.test(val);
  }
  onChangeNumberValidation = (val)=>{
    return !/^[0-9\b]+$/.test(val);
  }

  render = () => {
    const valid=this.state.valid;
    const enabled = this.isAllConditionsValid(valid);
    const { showGlobalErr, showExternalAccountValidationGlobalMsg } = this.state;
    const popup =(this.state.popupWindow?<ToolTipPopup togglePopupWindow={this.togglePopupWindow}/>:null);
    return (
      <div className="">
        <div className="row">
          <div className="col-xs-12">
            <div className="add-bank-account margin-t-m-15">
              <form className="was-validated" onSubmit={(e) => { e.preventDefault(); }}>
                <div className="your-loan-details add-bank-acc-heading">
                      Add bank account
                </div>
                <div className="row">
                  <div className="col-xs-12 btn-group margin-b-15 bankAccountTabs">
                    <button className={this.state.switchButtonPrimarySecondary? 'col-xs-6 btn btn-secondary savingsAccountTab savingTabRight btn-radius-cust right-buttons-toggle-cust-unactive' : 'col-xs-6 btn btn-primary checkingAccountTab checkingTabLeft  btn-radius-cust'}
                      onClick={()=>this.togglePrimarySecondaryBtn("CHECKING")} data-account="CHECKING">Checking</button>
                    <button className={this.state.switchButtonPrimarySecondary? 'col-xs-6 btn btn-primary checkingAccountTab checkingTabLeft btn-radius-cust' : 'col-xs-6 btn btn-secondary savingsAccountTab savingTabRight btn-radius-cust left-buttons-toggle-cust-unactive'}
                      onClick={()=>this.togglePrimarySecondaryBtn("SAVINGS")} data-account="SAVINGS">Savings</button>
                  </div>
                </div>

                <div className="helpful-tooltip-wrapper helpful-tooltip-wrapper-margin">
                  <div className="tooltip-container" tabIndex="0" onClick={()=>this.togglePopupWindow(false)}
                    onKeyDown={e=> {
                      let key = e.keyCode;
                      key === 13 ? this.togglePopupWindow(false) : null;
                      key === 32 ? this.togglePopupWindow(false) : null;
                    }}>
                    <span className="input-label-info-icon standard-blue">&#9432; <span className="tooltip-label">Locate your account and routing number</span></span>
                  </div>

                </div>
                {popup}

                { (showGlobalErr || showExternalAccountValidationGlobalMsg) && (
                  <p className="err-block-global " role="alert">{this.state.commonErrors}</p>
                )}

                <div className="form-group question-icon">
                  <label htmlFor="routingNum" className="addbank-input-label">Routing number</label>
                  <input type="text" maxLength="9" minLength="9" className="form-control addbank-input-textbox" id="routingNum" placeholder="Enter routing number" name="routingNum"
                    onBlur={(e)=>this.doValidation({ type: "req", field: "rn", val: e.target.value, size: 9 })}
                    pattern="^[0-9]+$" value={this.state.routingNumber}
                    onChange={(e) => {
                      this.setState({ showExternalAccountValidationGlobalMsg: false });
                      this.onChange('routingNumber', e.target.value );
                      this.doValidation({ type: "icon", field: "rn", val: e.target.value, size: 9 });
                    }}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } } } />
                  <i className={`right-tick-image ${valid.rn.icon.classes}`}></i>
                  <div className={`invalid-feedback ${valid.rn.req.classes}`} role="alert">{valid.rn.msg[valid.rn.index]}</div>
                  <div className="invalid-routing" role="alert">{this.state.invalidRoutingMessage}</div>
                </div>

                <div className="form-group question-icon">
                  <label htmlFor="accNum" className="addbank-input-label">Account number</label>
                  <input type="text" maxLength="17" minLength="4" className="form-control addbank-input-textbox" id="accNum" placeholder="Enter account number" name="accNum"
                    pattern="^[0-9]+$" value={this.state.accountNumber}
                    onBlur={(e)=> {
                      this.doValidation({ type: "req", field: "an", val: e.target.value, size: 4 });
                      this.validateAccountNumber(e);
                      this.confirmAccountNumberValidation();
                    }}
                    onKeyUp={(e)=>{
                      this.confirmAccountNumberValidation();
                    }}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                      this.confirmAccountNumberValidation();
                    }}
                    onChange={(e) => {
                      this.onChange('accountNumber', e.target.value );
                      this.doValidation({ type: "icon", field: "an", val: e.target.value, size: 4 });
                      this.confirmAccountNumberValidation();
                    }}
                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }} />
                  <i className={`right-tick-image ${valid.an.icon.classes}`}></i>
                  <div className={`invalid-feedback ${valid.an.req.classes}`} role="alert">{valid.an.msg[valid.an.index]}</div>
                  <div className="invalid-routing" role="alert">{this.state.dupalicateAccountMessage}</div>
                </div>

                <div className="form-group  question-icon ">
                  <label htmlFor="confirmAccNum" className="addbank-input-label">Re-enter account number</label>
                  <input type="text" maxLength="17" minLength="4" className="form-control addbank-input-textbox" id="confirmAccNum"
                    placeholder="Re-enter account number" name="confirmAccNum"
                    pattern="^[0-9]+$" value={this.state.confirmAccountNumber}
                    onBlur={(e)=>{
                      this.validateAccountNumber(e);
                      this.doValidation({ type: "req", field: "can", val: e.target.value, size: 4, compareWith: this.state.accountNumber });
                    }}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    onChange={(e) => {
                      this.onChange('confirmAccountNumber', e.target.value );
                      this.doValidation({ type: "icon", field: "can", val: e.target.value, size: 4, compareWith: this.state.accountNumber });
                    }}
                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
                    onContextMenuCapture={(event) => { event.preventDefault(); } }
                    onPaste={(event) => { this.onPaste(); event.preventDefault(); }}
                  />
                  <i className={`right-tick-image ${valid.can.icon.classes}`}></i>
                  <div className={`invalid-feedback ${valid.can.req.classes}`} role="alert">{valid.can.msg[valid.can.index]}</div>
                </div>

                <div className="form-group">
                  <label htmlFor="nicknm" className="addbank-input-label">Account nickname</label>
                  <input type="text" maxLength="12" minLength="1" className="addbank-input-textbox form-control" id="nicknm" placeholder="Enter account nickname" name="nicknm"
                    pattern="^[A-Za-z0-9'&#()/,\.-]*$" value={this.state.nickname}
                    onBlur={(e)=>{
                      this.doValidation({ type: "req", field: "nn", val: e.target.value, size: 1 });
                    }}
                    onKeyDown={e=>{
                      if(e.keyCode===13){
                        e.target.blur();
                      }
                    }}
                    onChange={(e) => {
                      this.onChange('nickname', e.target.value );
                      this.doValidation({ type: "req", field: "nn", val: e.target.value, size: 1 });
                    }}
                    onKeyPress={(event) => { this.nickNameValidation(event); }}/>
                  <div className={`invalid-feedback ${valid.nn.req.classes}`} role="alert">{valid.nn.msg[valid.nn.index]}</div>
                  <div className="invalid-routing" role="alert">{this.state.dupalicateNicknameMessage}</div>
                  <div className="invalid-routing" role="alert">{this.state.profabityNicknameCheckMessage}</div>
                </div>
                <section className="col-12 text-btn-center add-bank m-m-15">
                  <button type="submit" data-track="custom-links" aria-label="click to continue" disabled={!enabled} onClick={this.addBankAccount}>Continue</button>
                </section>
                <input className="hidden" value={this.state.externalAccountType} id="accountType" hidden
                  name="disbursementInformation.ddaPayment.directDepositAccount.externalAccountType" readOnly />
                <input name="disbursementInformation.ddaPayment.amount.amount" data-validate="required alphaName" value="1000" type="hidden" id="damount" readOnly/>
                <input name="disbursementInformation.ddaPayment.amount.currency" placeholder="loan amount" value="USD" type="hidden" id="dcurrency" readOnly/>

              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddBankAccount;
